// extracted by mini-css-extract-plugin
export default {"scrollButton":"ScrollToBottom_scrollButton__LGaIc","light":"ScrollToBottom_light__Y8S-4","dark":"ScrollToBottom_dark__OIcof"};